// This is a global that modules can use to store a reference to themselves
// when they're loaded.  This is used as a replacement for
// require.LegacyRequireIfLoaded.
// WARNING: Do not use this in new code.
export const LegacyRequireIfLoaded: Partial<{ScratchpadUIModule: any}> = {};
